// specific to SA
import Component from '../../UM-Base/components/Component';

export default class Analytics extends Component {
  load() {
    // console.log('Analytics component');

    (async() => {
      // non blocking
      // wait for Adobe Launch to set the "window.Visitor" function.
      while(typeof window.Visitor != "function")
          await new Promise(resolve => setTimeout(resolve, 1000));
      // console.log("Visitor function is defined.");
      this.initAnalytics();
    })();

    super.load();
  }

  initAnalytics() {
    let urlsToTrack = window.includedUrls;

    //find all external link and add unique used id as query string
    var visitor = Visitor.getInstance("713FA49558454ABE0A495EAD@AdobeOrg", {
      trackingServer: "satc.sc.omtrdc.net", // same as s.trackingServer
      trackingServerSecure: "satc.sc.omtrdc.net", // same as s.trackingServerSecure
    });

    //get the Experience Cloud ID and pass it to the function
    var mcId = visitor.getMarketingCloudVisitorID();
    if(mcId) {
      //Insert the code to dynamically append the mcID to external URLs client side
      var externalLinkStage = $(".stage-1-content a[href^='http'],.stage-2-content a[href^='http']")
        .not(".footer a[href^='http']")
        .not(".share-button__container a[href ^= 'http']"); //filter out footer and sharing links
        if(!!urlsToTrack) {
          externalLinkStage.each(function() {
            //Remove pre-existing satcMcId query string - ([?&]satcmcid=)\w+
            const regex = /([?&](satcMcId|satcmcid)=)\w+/g;
            var url = this.href.replace(regex, '');
            let parseUrl = new URL(url);
            if(urlsToTrack.toLowerCase().includes(parseUrl.host.toLowerCase())) {
              if(url.indexOf('?') === -1) {
                //if there is no query string with link
                this.href = url + "?satcMcId=" + mcId;
              } else {
                this.href = url + "&satcMcId=" + mcId;
              }
            }
          });
        }
    }
  }
}
